"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LearnMoreWrap = exports.LearnMoreModalWrap = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _modal = _interopRequireDefault(require("@ux/modal"));
const intents = new _intents.default();
"l1r5nr38";
const LearnMoreWrap = exports.LearnMoreWrap = /*#__PURE__*/(0, _react.styled)("div")({
  name: "LearnMoreWrap",
  class: "l1bkgba7"
});
const LearnMoreModalWrap = exports.LearnMoreModalWrap = /*#__PURE__*/(0, _react.styled)(_modal.default)({
  name: "LearnMoreModalWrap",
  class: "l17c7jy6"
});